function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "interior-toggle_svg__a",
  d: "M0 0h20v20H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.282 4.23a.833.833 0 01.782-.204l.16.041a1.474 1.474 0 011.109 1.376.84.84 0 01-.022.224l-.4 1.659a.836.836 0 00.022.465l.038.109a.831.831 0 01-.02.593l-2.953 6.998a.834.834 0 01-.826.507l-5.974-.408a.517.517 0 01-.482-.478l-.043-.574a2.12 2.12 0 01.478-1.506.83.83 0 01.375-.26 5.379 5.379 0 012.87-.164l.778.168a.421.421 0 00.511-.41v-.512a.83.83 0 01.142-.464l2.495-3.706c.128-.19.148-.424.099-.648a1.348 1.348 0 01-.013-.455l.102-.821a2.55 2.55 0 01.772-1.53z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 1.337c-4.777 0-8.663 3.886-8.663 8.663S5.223 18.663 10 18.663s8.663-3.886 8.663-8.663S14.777 1.337 10 1.337M10 20C4.487 20 0 15.514 0 10S4.487 0 10 0c5.514 0 10 4.486 10 10s-4.486 10-10 10",
  fill: "#FFF",
  fillRule: "nonzero"
}));

function SvgInteriorToggle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgInteriorToggle;